import { Flex, FolderIcon, NewspaperIcon, Skeleton } from '@buffer-mono/popcorn'

import { FeedItemIcon } from '../FeedIcon/FeedIcon'

import styles from './ListHeader.module.css'

import type { JSX } from 'react'

type ListHeaderIconProps = {
  title: string
  isLoading: boolean
  isCollection: boolean
  domain?: string
}

export const ListHeaderIcon = ({
  title,
  isCollection,
  domain,
  isLoading,
}: ListHeaderIconProps): JSX.Element => {
  if (isLoading) {
    return (
      <Skeleton
        className={styles.skeletonNoShrink}
        width={32}
        height={32}
        rounded
      />
    )
  }

  if (isCollection) {
    return (
      <Flex
        align="center"
        justify="center"
        className={styles.titleIconContainer}
      >
        <FolderIcon aria-hidden="true" className={styles.titleIcon} />
      </Flex>
    )
  }

  if (!domain) {
    return (
      <Flex
        align="center"
        justify="center"
        className={styles.titleIconContainer}
      >
        <NewspaperIcon aria-hidden="true" className={styles.titleIcon} />
      </Flex>
    )
  }

  return (
    <FeedItemIcon
      feedName={title}
      url={domain}
      aria-hidden="true"
      size="medium"
    />
  )
}
